module.exports = __webpack_public_path__ + "img/Fregier.97f4f65c.png";